import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/workflow-reports/creators/{creatorId}/court-calendar/filters';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getCourtCalendarFilters = async ({ creatorId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/workflow-reports/creators/${creatorId}/court-calendar/filters`, {
    params: {
      creatorId,
    },
  });
  return response.data;
};

export default getCourtCalendarFilters;
